import React from "react";
import {
  Box,
  Container,
  Typography,
  Link,
  Divider,
  IconButton,
  Stack,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import { useTranslation } from "react-i18next";
import LogoImage from "images/logo/ncc-logo.png";
import pMarkLogo from "images/logo/pmark_75.gif";

export default () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        bgcolor: "#0c4d96",
        color: "white",
        pt: 4,
        pb: 2,
        ml: -4,
        mr: -4,
        mb: -4,
      }}
    >
      <Container maxWidth="lg">
        {/* Logo Section */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 2,
          }}
        >
          <Box
            component="img"
            src={LogoImage}
            alt="Company Logo"
            sx={{
              width: 160,
              mb: 2,
            }}
          />
        </Box>

        {/* Address Section */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography
            variant="body2"
            sx={{
              color: "rgba(255,255,255,0.8)",
              maxWidth: 300,
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            {t("company_location.address.address_line1")}
            <br />
            {t("company_location.address.address_line2")}
            <br />
            {t("company_location.address.address_line3")}
          </Typography>
        </Box>

        {/* Links Sections */}
        <Stack spacing={3} sx={{ mb: 4 }}>
          {/* Quick Links */}
          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="subtitle2"
              sx={{
                color: "rgba(255,255,255,0.9)",
                fontWeight: 600,
                mb: 2,
              }}
            >
              {t("footer_quick_link")}
            </Typography>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="center"
              sx={{
                flexWrap: "wrap",
                gap: 1,
                "& > *": {
                  mx: 1,
                  my: 0.5,
                },
              }}
            >
              <Link
                href="/it-service"
                sx={{
                  color: "rgba(255,255,255,0.8)",
                  textDecoration: "none",
                  "&:hover": { color: "white" },
                }}
              >
                {t("header_nav_service")}
              </Link>
              <Link
                href="/business"
                sx={{
                  color: "rgba(255,255,255,0.8)",
                  textDecoration: "none",
                  "&:hover": { color: "white" },
                }}
              >
                {t("header_nav_business")}
              </Link>
              <Link
                href="/company"
                sx={{
                  color: "rgba(255,255,255,0.8)",
                  textDecoration: "none",
                  "&:hover": { color: "white" },
                }}
              >
                {t("header_nav_aboutus")}
              </Link>

              <Link
                href="/recruitment"
                sx={{
                  color: "rgba(255,255,255,0.8)",
                  textDecoration: "none",
                  "&:hover": { color: "white" },
                }}
              >
                {t("header_nav_recruitment")}
              </Link>
            </Stack>

            <Stack
              direction="row"
              spacing={2}
              justifyContent="center"
              sx={{
                flexWrap: "wrap",
                mt: 2,
                gap: 1,
                "& > *": {
                  mx: 1,
                  my: 0.5,
                },
              }}
            >
              <Link
                href="/employee"
                sx={{
                  color: "rgba(255,255,255,0.8)",
                  textDecoration: "none",
                  "&:hover": { color: "white" },
                }}
              >
                {t("header_nav_employee")}
              </Link>

              <Link
                href="/contact"
                sx={{
                  color: "rgba(255,255,255,0.8)",
                  textDecoration: "none",
                  "&:hover": { color: "white" },
                  fontSize: "0.9rem",
                }}
              >
                {t("header_nav_contactus")}
              </Link>

              <Link
                href="/privacy-policy"
                sx={{
                  color: "rgba(255,255,255,0.8)",
                  textDecoration: "none",
                  "&:hover": { color: "white" },
                  fontSize: "0.9rem",
                }}
              >
                {t("header_nav_privacy_policy")}
              </Link>
            </Stack>
          </Box>
        </Stack>

        {/* Contact Section */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
            {t("footer_conact_phone")}
          </Typography>
          <Link
            href={`mailto:${t("footer_contact_email_soumu")}`}
            sx={{
              color: "rgba(255,255,255,0.8)",
              textDecoration: "none",
              display: "block",
              fontSize: "0.9rem",
              mt: 1,
              "&:hover": { color: "white" },
            }}
          >
            {t("company_location.address.email_soumu")}
          </Link>
          <Link
            href={`mailto:${t("footer_contact_email_sales")}`}
            sx={{
              color: "rgba(255,255,255,0.8)",
              textDecoration: "none",
              display: "block",
              fontSize: "0.9rem",
              mt: 1,
              "&:hover": { color: "white" },
            }}
          >
            {t("company_location.address.email_sales")}
          </Link>
        </Box>

        <Divider sx={{ borderColor: "rgba(255,255,255,0.1)", mb: 3 }} />

        {/* Bottom Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Link href="https://privacymark.jp/">
            <Box
              component="img"
              src={pMarkLogo}
              alt="P Mark Logo"
              sx={{
                width: 48,
                borderRadius: 1,
                backgroundColor: "white",
              }}
            />
          </Link>

          <Typography
            variant="caption"
            sx={{
              color: "rgba(255,255,255,0.7)",
              textAlign: "center",
              mt: 1,
            }}
          >
            {t("footer_copyright")}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
